import styled from 'styled-components'

export const DateNumber = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 33px;
  height: 33px;
  border-radius: 50%;
  color: ${props => props.theme.primaryColor};
  border: 1px solid #f3f3f5;
  font-weight: 500;
  font-size: 14px;
  pointer-events: none;
  user-select: none;
  background: #fff;
  line-height: 33px;
`

export const DayGroup = styled.div<{ active?: boolean }>`
  padding: 32px 16px 24px 24px;
  border-bottom: 1px solid #e6e8eb;
  display: flex;
  align-items: flex-start;

  &.active {
    background-color: ${props => props.theme.primaryColor}05;
    border-left: ${props => `3px solid ${props.theme.primaryColor}`};
    padding-left: 21px;

    ${DateNumber} {
      border: none;
      background-color: ${props => props.theme.primaryColor};
      color: ${props => props.theme.secondaryFontColor};
    }
  }
`

export const DateLabel = styled.div`
  display: flex;
  align-items: center;
  width: 210px;
  padding-top: 10px;
`

export const DateInfo = styled.div`
  padding-left: 8px;
  font-size: 16px;

  .month-name {
    font-weight: 500;
    text-transform: capitalize;
  }

  .week-day-name {
    text-transform: capitalize;
  }

  .week-number {
    display: block;
    font-size: 14px;
    color: #a1a5b0;
  }
`

export const EventList = styled.div`
  border: 1px solid #e6e8eb;
  border-radius: 6px;
  flex-grow: 1;
  background: white;
`

export const Event = styled.div<{ color?: string }>`
  display: flex;
  padding: 10px 8px;
  cursor: pointer;
  gap: 12px;

  &:hover {
    background-color: ${props => props.color}15;
  }

  &:not(:last-child) {
    border-bottom: 1px solid #e6e8eb;
  }
`

export const User = styled.div`
  width: 260px;
`

export const Type = styled.div<{ color?: string }>`
  display: flex;
  align-items: center;
  font-size: 16px;
  color: ${props => props.color};

  &::before {
    display: inline-flex;
    content: '';
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: ${props => props.color};
    margin-right: 8px;
  }
`

export const AwaitingApproval = styled.span`
  display: inline-flex;
  align-items: center;
  align-self: center;
  line-height: 1;
  padding: 4px;
  border: 1px solid #e6e8eb;
  border-radius: 4px;
  background: #f9f9fa;
  color: #a1a5b0;
`
